import axios from "axios";
import { Message } from "element-ui";
import { logToConsole } from "../common/LogHelper";
import { request as newRequest } from "../request/index";//别删，注释中有引用
import { RootActionNames, RootStore } from '@/vuex-store';

export const CODE_SUCCESS = 0;
export const CODE_SERVER_EXCEPTION = 1;
export const CODE_ACCESS_TOKEN_INVALID = 14;
export const CODE_SENTENCE_TOO_LONG = 22;

export const MSG_SERVER_EXCEPTION = "服务繁忙，可稍后尝试或联系客服";
export const MSG_NETWORK_ERROR = "网络错误，检查网络状态后重试";
export const MSG_LOCAL_EXCEPTION = "发生错误，可尝试刷新页面或联系客服"; //本地代码异常
export const SERVER_EXCEPTION_RESP = {
    code: CODE_SERVER_EXCEPTION,
    msg: MSG_SERVER_EXCEPTION,
};

export const DEFAULT_TIMEOUT = 60 * 1000;

// 请求头 后续了解一下下面 做好注释 有点忘记了
axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
/**
 * @deprecated 使用{@link newRequest @/request/index中的request}代替
 * 发送请求失败，网络错误等原因没有响应信息时，
 * 会catch()中返回对应的错误，服务器有响应时(包括http状态码不为2xx)会在then()中返回
 * 服务器响应的数据{@link BaseReqResponse}，http状态码不为2xx时then()中会返回
 * {@link SERVER_EXCEPTION_RESP}
 * @typedef {ReqResponse & {data: any}} BaseReqResponse
 * @param {import("axios").AxiosRequestConfig} config
 * @param {boolean} isShowToast 服务器没有返回{@link BaseReqResponse}数据或
 * 返回的{@link BaseReqResponse}数据中code不为0时是否自动显示对应的错误信息
 * @returns {Promise<BaseReqResponse>}
 */
export function request(config, isShowToast = true) {
    // 1.创建axios的实例
    const instance = axios.create({
        // 设置请求头类型 不然会出现多一次请求 options
        method: "POST",
        /**
         * npm run build/serve => 使用的是测试服，开发环境为development
         * npm run build/serve => 使用的是正式服，开发环境为production
         * npm run build/serve -- --mode proddev => 使用的是正式服，开发环境为development
         * npm run build/serve -- --mode testdev => 使用的是测试服，开发环境为development
         * npm run build/serve -- --mode testprod => 使用的是测试服，开发环境为production
         * npm run build/serve -- --mode localdev => 使用的是本地作为服务器，开发环境为development
         */
        baseURL: process.env.VUE_APP_SERVER_URL,
        timeout: DEFAULT_TIMEOUT,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
    });
    // 2.aixos拦截器
    // 2.1发送请求拦截
    instance.interceptors.request.use((config) => {
        // 全局的 每次请求都会带上token参数
        const accessToken = RootStore.state.currUser?.accessToken;
        if (accessToken) {
            config.data
                ? (config.data.accessToken = accessToken)
                : (config.data = {
                      accessToken: accessToken,
                      ...config.data,
                  });
        }

        return config; //拦截之后记得return 不然控制台错误没有res信息输出
    });

    // 2.2发送响应拦截
    instance.interceptors.response.use(
        (res) => {
            //检查响应是否正确
            if (!res.data || !res.data.hasOwnProperty("code")) {
                console.log("res.data", res.data);
                return SERVER_EXCEPTION_RESP;
            }

            const resultCode = parseInt(res.data.code);
            if (resultCode === CODE_ACCESS_TOKEN_INVALID)
                RootStore.dispatch(RootActionNames.logout);
            if (resultCode !== CODE_SUCCESS && isShowToast) {
                Message.error({
                    message: res.data.msg ? res.data.msg : MSG_SERVER_EXCEPTION,
                    center: true,
                    showClose: true,
                });
            }
            return res.data;
        },
        (error) => {
            logToConsole("请求错误：", { ...error });
            if (!isShowToast) return Promise.reject(error);
            if (error.response) {
                //请求已经发出，但服务器响应的http状态码非2xx
                Message.error(MSG_SERVER_EXCEPTION);
                return SERVER_EXCEPTION_RESP;
            } else if (error.request)
                //请求已经发出，但没有响应，一般是网络问题，请求超时，
                //找不到主机ip，网络地址错误等问题
                Message.error(MSG_NETWORK_ERROR);
            //请求没有发出，在组装请求信息时发生异常
            else Message.error(MSG_LOCAL_EXCEPTION);

            return Promise.reject(error);
        }
    );

    // 3.发送真正的网络请求
    return instance(config);
}

// post
